import back1 from './back.png'
import back2 from './back2.png'
import back3 from './back3.png'

export const backImage1 = back1;
export const backImage2 = back2;
export const backImage3 = back3;
